import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-default-standard-shipping',
  templateUrl: './tooltip-default-standard-shipping.component.html',
  styleUrls: ['./tooltip-default-standard-shipping.component.scss'],
  standalone: false
})
export class TooltipDefaultStandardShippingComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
